import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/services/main/main.service';
import { GlobalFilterService } from 'src/app/services/shared/global-filter.service';
import { SocketsService } from 'src/app/services/shared/socket.service';
import { getUserProfiles, getDoctorSettings } from 'src/app/core/session';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications: any[];
  search_string = '';
  type = 0;
  filter = 0;
  type_Arr = ['Type', 'Contracts', 'Claims', 'Payouts','','Leads', 'Subscriptions', 'Proposals']
  selected_nav = 1;
  page_number = 1;
  totalRecords = 0;
  locationFilter;
  locationSubscription;
  userInfo = getUserProfiles();
  doctorSettings = getDoctorSettings();
  popup = false;
  doctor_id: any;
  proposal_notification_setting: any;
  constructor(public _main: MainService, public _router: Router, public _routes: ActivatedRoute, public globalFilterService: GlobalFilterService, public _socket: SocketsService, public dialogRef: MatDialogRef<NotificationsComponent>) { }

  ngOnInit() {
    this.getNotifications();
    if (this.userInfo && this.userInfo[0] && this.userInfo[0].role_id == 5) {
      this.locationFilter = this.globalFilterService.getFilterObj('location');
      this.locationSubscription = this.globalFilterService.locationFilter
        .subscribe((filter) => {
          this.locationFilter = filter;
          this.getNotifications();
        });
    }
    this.proposal_notification_setting = 0;
    if (this.doctorSettings && this.doctorSettings.proposal_notification_setting) {
      this.proposal_notification_setting = this.doctorSettings.proposal_notification_setting;
    }
    this.filter = 0;
    this.type = 0;
    this._socket.socket.on('new_notification', (data) => {
      this._main.unread_count = data.unread_count;
      if (data.data) {
        if (data.data.length > 10) {
          this.notifications = data.data.slice(0, 10);
        } else {
          this.notifications = data.data;
        }
      }
      this.totalRecords = data.count;
      this.notifications.forEach(element => {
        element.show_sent_at = this._main.covertDateTimesAgo(element.sent_at)
      });
      this.page_number = 1;
    })
    setInterval(() => {
      this.scrollHandler()
    }, 1000)
    if (this.userInfo && this.userInfo[0] && this.userInfo[0].doctor_id) {
      this.doctor_id = this.userInfo[0].doctor_id;
    }
  }

  api_hitting = false;
  scrollHandler() {
    var element = document.querySelector('#infinite-scroller');
    if (element) {
      var position = element.getBoundingClientRect();
      if ((position.top >= 0 && position.bottom <= window.innerHeight) || (position.top < window.innerHeight && position.bottom >= 0)) {
        if (this.totalRecords != this.notifications.length && this.api_hitting == false) {
          this.page_number = this.page_number + 1;
          this.getNotifications();
        }
      }
    }
  }

  getNotifications() {
    let params = {
      access_token: localStorage.getItem('token'),
      limit: 10,
      offset: (this.page_number - 1) * 10,
      search_string: this.search_string,
      type: this.type != 0 ? this.type : '',
      filter: this.filter != 0 ? this.filter : '',
      hideLoader: true
    };
    if (this.locationFilter && this.locationFilter.id) {
      params['doctor_id'] = this.locationFilter.id;
    }
    this.api_hitting = true;
    this._main.api(params, 'fetch_business_notifications', false)
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          if (this.page_number == 1) {
            this.notifications = data.data;
          } else {
            this.notifications = [...this.notifications, ...data.data];
          }
          this._main.notification_list = this.notifications;
          this.totalRecords = data.count;
          this.notifications.forEach(element => {
            element.show_sent_at = this._main.covertDateTimesAgo(element.sent_at)
          });

          this._main.unread_count = data.unread_count;

        }
        this.api_hitting = false;
      })
  }

  readNotification(id?) {
    let params = {
      access_token: localStorage.getItem('token')
    };
    if (id) {
      params['bn_id'] = id;
    }
    if (this.locationFilter && this.locationFilter.id) {
      params['doctor_id'] = this.locationFilter.id;
    }
    this._main.api(params, 'read_business_notifications', false)
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.page_number = 1; this.type = 0; this.filter = 0;
          this.getNotifications();
        }
      })
  }

  navToNotification(notification) {
    if (notification && notification.read_at == null) {
      this.readNotification(notification.bn_id);
    }
    switch (notification.type) {
      case 1:
        // contract
        let contract
        if (typeof notification.metadata == 'string') {
          contract = JSON.parse(notification.metadata);
        }
        else {
          contract = notification.metadata;
        }
        if (notification.title.includes('Dispute Documents')) {
          this._router.navigate(['/app/profile'], { queryParams: { id: contract.contract_code,type:"dispute" } });
        } else if (notification.pn_id == 116) {
          this._router.navigate(['/app/contract/list'], { queryParams: { pfStatus: 9 } });
        } else {
          this._router.navigate(['/app/contract/details'], { queryParams: { contractId: contract.contract_id } });
        }
        break;
      case 2:
        // claim
        let claim
        if (typeof notification.metadata == 'string') {
          claim = JSON.parse(notification.metadata);
        }
        else {
          claim = notification.metadata;
        }
        if(notification && notification.pn_id == 26){
          if(notification.total_document_required > 0){
            this._router.navigate(['/app/claims-v2/list'], { queryParams: { search: claim.contract_code } });
          } else {
            this._router.navigate(['/app/claims-v2/list'], { queryParams: { search: claim.contract_code } });
          }
        } else {
          if (claim && claim.redirect_to_contract && claim.contract_id) {
            this._router.navigate(['/app/contract/details'], { queryParams: { contractId: claim.contract_id } });
          } else {
            this._router.navigate(['/app/claims-v2/list'], { queryParams: { search: claim.claim_id } });
          }
        }
        break;
      case 3:
        // payout
        let payout
        if (typeof notification.metadata == 'string') {
          payout = JSON.parse(notification.metadata);
        }
        else {
          payout = notification.metadata;
        }
        if (notification && notification.pn_id == 21) {
          this._router.navigate(['/app/profile']);
        } else {
          this._router.navigate(['/app/reports/payout-details'], { queryParams: { payoutId: payout.payout_id, locationId: this.doctor_id } });
        }
        break;
      case 4:
        this._router.navigate(['app/profile'], { queryParams: { tab: 'subscription' } });
        break
      case 5:
        let lead_meta_data = {};
        if (typeof notification.metadata == 'string') {
          lead_meta_data = JSON.parse(notification.metadata);
        }
        else {
          lead_meta_data = notification.metadata;
        }
        this._router.navigate(['app/leads/details'], { queryParams: { application_id: lead_meta_data['application_id'] } });
        break
      case 6:
        let pp_sub_metadata = {};
        if (typeof notification.metadata == 'string') {
          pp_sub_metadata = JSON.parse(notification.metadata);
        }
        else {
          pp_sub_metadata = notification.metadata;
        }
        this._router.navigate(['app/process-payment/sub-details'], { queryParams: { processId: pp_sub_metadata['pp_subscription_id'] } });
        break
      case 7:
        let proposal_noty_metadata = {};
        if (typeof notification.metadata == 'string') {
          proposal_noty_metadata = JSON.parse(notification.metadata);
        }
        else {
          proposal_noty_metadata = notification.metadata;
        }
        if(proposal_noty_metadata && proposal_noty_metadata['contract_type'] == 5){
          this._router.navigate(['app/accounts-receivable/split-details'], { queryParams: { splitId: proposal_noty_metadata['split_req_id'] } });
        } else {
          this._router.navigate(['app/contract/split-details'], { queryParams: { splitId: proposal_noty_metadata['split_req_id'] } });
        }
        break
    }
    this.closeNotificationfun();
  }

  show_popup() {
    if (!this.popup) {
      setTimeout(() => {
        this.popup = true;
      }, 100)
    }
  }

  ngAfterViewInit() {
    window.addEventListener('click', (event) => {
      if (this.popup == true && event) {
        this.popup = false;
      }
    })
  }

  closeNotificationfun() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.locationSubscription && this.locationSubscription.unsubscribe();
  }

}
